import '../styles/NavigationMobile.css';
import { array } from 'prop-types';
import Navbar from 'react-bootstrap/Navbar';
import NavigationMobileMenuItem from './NavigationMobileMenuItem';
import Offcanvas from 'react-bootstrap/Offcanvas';
import React, { forwardRef } from 'react';


const NavigationMobile = forwardRef(({ navData }, ref) => {
    return (<Navbar.Offcanvas
        className={'nav-mobile'}
        placement={'start'}>
        <Offcanvas.Body
            className={'nav-mobile--body'}
            ref={ref}>
            <div>
                {navData.map((navLink) => (<NavigationMobileMenuItem
                    key={navLink.id}
                    navLink={navLink}>
                </NavigationMobileMenuItem>))}
            </div>
        </Offcanvas.Body>
    </Navbar.Offcanvas>);
});

NavigationMobile.displayName = 'NavigationMobile';
NavigationMobile.propTypes = {
    navData: array,
};

export default NavigationMobile;